import React, { useEffect, useState } from "react";
import styles from "./triDashboard.module.css";
import calendarIcon from "../../../../assets/images/tms/calendar.png";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { SweetAlert } from "../../../../helpers/helper";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { PiDownloadSimpleDuotone } from "react-icons/pi";
import { CiCirclePlus } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { post } from "../../../../components/api";
import DataTable from "react-data-table-component";
import Loading from "../../../../components/Loading";
import { BsThreeDotsVertical } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { MdDeleteOutline } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";

const DoughnutGraph = ({ data, name }) => {
  const allZero = data.datasets[0].data.every((value) => value === 0);

  return (
    <>
      <div className={styles.heading}>
        <p>{name}</p>
      </div>
      <div className={styles.graph}>
        {allZero ? (
          <div style={{ padding: "90px 30px" }}>No Data Avialable</div>
        ) : (
          <Doughnut
            width={200}
            height={200}
            data={data}
            options={{
              aspectRatio: 1,
              cutout: "70%",
              plugins: {
                legend: {
                  display: false,
                },
              },
            }}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: 12,
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {data.datasets[0].data.map((value, index) => {
          const color = data.datasets[0].backgroundColor[index];
          return (
            <>
              <div key={index} style={{ textAlign: "center" }}>
                <p style={{ fontSize: "22px", color: color }}>{value}</p>
                <div style={{ fontWeight: 400 }}>{data.labels[index]}</div>
              </div>
              {index < data.datasets[0].data.length - 1 && (
                <svg
                  width="2"
                  height="56"
                  viewBox="0 0 2 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 0V55.8967"
                    stroke="#668FA3"
                    strokeWidth="1.36333"
                  />
                </svg>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};

const TripDashboard = () => {
  const navigate = useNavigate();
  const [startDate, setStart] = useState(
    moment().subtract(6, "days").startOf("day").toDate()
  );
  const [endDate, setEnd] = useState(moment().endOf("day").toDate());
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [tripType, setTripType] = useState([]);
  const [tripData, setTripData] = useState([]);
  const [graph1, setGraph1] = useState({
    running: 0,
    completed: 0,
    schedule: 0,
  });
  const [graph2, setGraph2] = useState({ early: 0, On_Time: 0, Delay: 0 });
  const [graph3, setGraph3] = useState({
    early: 0,
    On_Time: 0,
    Delay: 0,
    Missed_Point: 0,
  });
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState();
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [editableTrip, setEditableTrip] = useState(null);
  const [formData, setFormData] = useState({
    status: "",
    date: null,
  });
  const [selectedTripData, setSelectedTripData] = useState({});

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <BsThreeDotsVertical size={"20px"} color="#2A7C7A" />
    </a>
  ));

  CustomToggle.displayName = "CustomToggle";

  useEffect(() => {
    setTripType([
      { label: "Empty", value: "empty" },
      { label: "Waiting To Load", value: "waiting_to_load" },
      { label: "Loading", value: "loading" },
      { label: "Loaded", value: "loaded" },
      { label: "In Transit", value: "in_transit" },
      { label: "Waiting To Unload", value: "waiting_to_unload" },
      { label: "Unloading", value: "unloading" },
      { label: "Unload", value: "unload" },
    ]);
  }, []);

  const fechGraphData = async () => {
    const response = await post("admin/tms/trip-dashboard", {
      startDate,
      endDate,
      selected,
      search,
    });
    setTripData(response?.data.findTrips);
    setGraph1(response?.data?.graph1);
    setGraph2(response?.data?.graph2);
    setGraph3(response?.data?.graph3);
    setTotalRows(10);
  };

  useEffect(() => {
    fechGraphData();
  }, [page, perPage, totalRows, startDate, endDate, selected]);

  const initialSettings = {
    startDate: startDate,
    endDate: endDate,
    timePicker: true,
    timePicker24Hour: false,
    alwaysShowCalendars: true,
    maxDate: moment().endOf("day").toDate(),
    // maxTime: moment().endOf("day").format("HH:mm"),
    locale: {
      format: "DD/MM/YYYY h:mm A",
    },
    opens: "left",
    ranges: {
      Today: [moment().startOf("day").toDate(), moment().toDate()],
      Yesterday: [
        moment().subtract(1, "days").startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate(),
      ],
      "Last 7 Days": [
        moment().subtract(6, "days").startOf("day").toDate(),
        moment().endOf("day").toDate(),
      ],
      "Last 15 Days": [
        moment().subtract(14, "days").startOf("day").toDate(),
        moment().toDate(),
      ],
      "This Month": [
        moment().startOf("month").startOf("day").toDate(),
        moment().endOf("month").endOf("day").toDate(),
      ],
      "Last Month": [
        moment().subtract(1, "month").startOf("month").startOf("day").toDate(),
        moment().subtract(1, "month").endOf("month").endOf("day").toDate(),
      ],
    },
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      background: "#ffffff",
      border: "1px solid #1D262F80",
      borderRadius: "6px",
      outline: "none",
      fontSize: "0.8rem",
      padding: "1px",
      minWidth: "200px",
      textAlign: "left",
    }),
    singleValue: (base) => ({
      ...base,
      fontFamily: "Outfit, sans-serif",
      fontWeight: 300,
      fontSize: "12px",
      lineHeight: "100%",
      letterSpacing: "0%",
      textAlign: "left",
    }),
    placeholder: (base) => ({
      ...base,
      fontFamily: "Outfit, sans-serif",
      fontWeight: 300,
      fontSize: "12px",
      lineHeight: "100%",
      letterSpacing: "0%",
      textAlign: "left",
    }),
    menuList: (base) => ({
      ...base,
      fontSize: "0.8rem",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#4C7889"
        : state.isFocused
        ? "#C3E8E8"
        : "#fff",
      color: state.isSelected ? "#ffffff" : "#000000",
      cursor: "pointer",
      display: "flex",
      justifyContent: "flex-start",
      textAlign: "left",
    }),
  };

  ChartJS.register(ArcElement, Tooltip, Legend);

  const data = {
    labels: ["Running", "Completed", "Schedule"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3],
        backgroundColor: [
          "rgba(228, 209, 4, 1)",
          "rgba(57, 156, 108, 1)",
          "rgba(95, 221, 37, 1)",
          "rgba(191, 59, 59, 1)",
        ],
        borderColor: [
          "rgba(228, 209, 4, 1)",
          "rgba(57, 156, 108, 1)",
          "rgba(95, 221, 37, 1)",
          "rgba(191, 59, 59, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const handleApplyDate = (event, picker) => {
    const selectedStart = picker.startDate;
    const selectedEnd = picker.endDate;
    if (selectedEnd.isBefore(selectedStart.clone().add(1, "months"))) {
      const startDateTime = moment(selectedStart).toDate();
      const endDateTime = moment(selectedEnd).toDate();
      setStart(startDateTime);
      setEnd(endDateTime);
    } else {
      SweetAlert(
        "Please select a date range within one month from the start date.",
        true
      );
    }
  };

  const handleEdit = (data) => {
    setShow(true);
    setEditableTrip(data._id);
    setSelectedTripData(data);
  };

  const handleDelete = (id) => {
    id;
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.tripName,
      sortable: true,
    },
    {
      name: "Vehicle",
      selector: (row) => row?.vehicleId?.vehicleNo,
    },
    {
      name: "Start Location",
      selector: (row) => row?.routeId?.routePoints[0].address,
    },
    {
      name: "End Location",
      selector: (row) =>
        row?.routeId?.routePoints[row?.routeId?.routePoints?.length - 1]
          .address,
    },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row.originReportingTime).format("DD/MM/YYYY HH:mm"),
    },
    {
      name: "Job Duration",
      selector: () => "11hours 30minutes",
    },
    {
      name: "Distance",
      selector: (row) =>
        `${
          row?.routeId?.routePoints[row?.routeId?.routePoints?.length - 1]
            .distance
        } KM`,
    },
    {
      name: "Vehicle Status",
      // selector: (row) => row?.status,
      cell: (row) => (
        <div className={styles.tab} style={{ border: "1px solid #668fa3" }}>
          <p style={{ color: "#668fa3" }}>{row.status}</p>
        </div>
      ),
    },
    {
      name: "Trip Status",
      cell: (row) => {
        return (
          <div className={styles.tab} style={{ border: "1px solid #668fa3" }}>
            <p
              style={{
                color: `${
                  row.timeStatus == "Delay"
                    ? "red"
                    : row.timeStatus == "Early"
                    ? "green"
                    : "#668fa3"
                }`,
              }}
            >
              {row.timeStatus}
            </p>
          </div>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle
            as={CustomToggle}
            style={{ display: "block", marginBottom: "50px" }}
          />
          <Dropdown.Menu
            size="sm"
            title="Actions"
            className={styles.action_dropdown}
            style={{
              position: "absolute",
              top: "80px", // Adjust height to position it above
              zIndex: 1000,
            }}
          >
            <Dropdown.Item>
              <div
                className="d-flex align-items-center"
                onClick={() =>
                  navigate("/tms/trip-details", { state: { id: row._id } })
                }
              >
                <IoEyeOutline color="#626c70" size={16} />
                <span className="invoice-btn-text">Trip View</span>
              </div>
            </Dropdown.Item>
            {row.status !== "unload" && (
              <Dropdown.Item>
                <div
                  className="d-flex align-items-center"
                  onClick={() => {
                    handleEdit(row);
                    setFormData({ ...formData, status: row.status });
                  }}
                >
                  <FiEdit color="#626c70" size={16} />
                  <span className="invoice-btn-text">Status change</span>
                </div>
              </Dropdown.Item>
            )}
            <Dropdown.Item>
              <div
                className="d-flex align-items-center"
                onClick={() => handleDelete(row.orderId)}
              >
                <MdDeleteOutline color="#626c70" size={20} />
                <span className="invoice-btn-text">Delete</span>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
      allowOverflow: true,
      button: true,
      width: "56px",
    },
  ];

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handleClose = () => {
    setShow(false);
    setEditableTrip(null);
  };

  const hadnleSubmit = async () => {
    const data = await post(
      `admin/tms/trip-status-change/${editableTrip}`,
      formData
    );
    setShow(!show);
    fechGraphData();
    console.log(data);
  };

  console.log(selectedTripData);

  return (
    <div className={`${styles.routes} ${styles.ml5}`}>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        // dialogClassName={styles.custom_modal_position}
      >
        <Modal.Header closeButton>
          <Modal.Title className={styles.modalHeader}>
            Edit Trip Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label className={styles.FormLabel}>
                Status Change
              </Form.Label>
              <Select
                value={tripType.find(
                  (option) => option.value === formData.status
                )}
                onChange={(selectedOption) =>
                  setFormData({ ...formData, status: selectedOption.value })
                }
                options={tripType}
                defaultValue={{
                  value: "empty",
                  label: "Empty",
                }}
                styles={customStyles}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className={styles.FormLabel}>Select Date</Form.Label>
              <DatePicker
                selected={formData.date}
                onChange={(date) => setFormData({ ...formData, date })}
                placeholderText="Select a date"
                className={styles.FormInput}
                showTimeSelect
                timeIntervals={15}
                dateFormat="yyyy-MM-dd h:mm aa"
                minDate={new Date(selectedTripData.routeStartTime)}
                maxDate={new Date()} // current date
                minTime={
                  formData.date &&
                  new Date(formData.date).toDateString() ===
                    new Date(selectedTripData.routeStartTime).toDateString()
                    ? new Date(selectedTripData.routeStartTime)
                    : new Date(0, 0, 0, 0, 0) // allow from start of day
                }
                maxTime={
                  formData.date &&
                  new Date(formData.date).toDateString() ===
                    new Date().toDateString()
                    ? new Date() // current time
                    : new Date(0, 0, 0, 23, 59) // allow until end of day
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <Button className={styles.cancleButton} onClick={handleClose}>
            Cancel
          </Button>
          <Button className={styles.submitButton} onClick={hadnleSubmit}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex justify-content-between mb-2">
        <h5 className={`${styles.title} text-left`}>All Trip</h5>
        <div className="d-flex gap-2">
          <div className={styles.HeaderSearchbar}>
            <input
              className={styles.Input}
              id="username"
              name="username"
              placeholder="Search Trip"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
          </div>
          <div className="position-relative">
            <img
              src={calendarIcon}
              className={styles.dateIcon}
              alt="Calendar Icon"
            />
            <DateRangePicker
              initialSettings={initialSettings}
              onApply={handleApplyDate}
            >
              <input type="text" className={styles.customInput} readOnly />
            </DateRangePicker>
          </div>
          <Button variant="primary" className={styles.downloadBtn}>
            <PiDownloadSimpleDuotone className="me-2" />
            Route Reports
          </Button>
          <Button
            variant="outline-primary"
            className={styles.outlineBtn}
            onClick={() => navigate("/tms/add/trip")}
          >
            <CiCirclePlus size={18} />
            <span className={styles.ml4}>Add</span>
          </Button>
        </div>
      </div>
      <div className={styles.mainCard}>
        <div className="d-flex justify-content-between">
          <div className={styles.graphCard}>
            <DoughnutGraph
              data={
                // graph1.running === 0 &&
                // graph1.completed === 0 &&
                // graph1.schedule === 0
                //   ? {
                //       ...data,
                //       labels: ["No Data"],
                //       datasets: data.datasets.map((dataset) => ({
                //         ...dataset,
                //         data: [1],
                //         backgroundColor: ["#e0e0e0"], // Add new value at the end
                //       })),
                //     }
                //   :
                {
                  ...data,
                  datasets: data.datasets.map((dataset) => ({
                    ...dataset,
                    data: [graph1.running, graph1.completed, graph1.schedule], // Add new value at the end
                  })),
                }
              }
              name={"Job Status"}
              style={{ height: "200px", width: "200px" }}
            />
          </div>
          <div className={styles.graphCard}>
            <DoughnutGraph
              data={{
                ...data,
                labels: ["Early", "On Time", "Delay"],
                datasets: data.datasets.map((dataset) => ({
                  ...dataset,
                  data: [graph2.early, graph2.On_Time, graph2.Delay], // Add new value at the end
                  backgroundColor: [...dataset.backgroundColor],
                  borderColor: [...dataset.borderColor],
                })),
              }}
              name={"Trip Status"}
            />
          </div>
          <div
            className={`${styles.graphCard} d-flex justify-content-between gap-4`}
          >
            <div>
              <DoughnutGraph
                data={{
                  ...data,
                  labels: ["Early", "On Time", "Delay", "MIssed Points"],
                  datasets: data.datasets.map((dataset) => ({
                    ...dataset,
                    data: [
                      graph3?.early,
                      graph3?.On_Time,
                      graph3?.Delay,
                      graph3?.Missed_Point,
                    ], // Add new value at the end
                  })),
                }}
                name={"Job Status"}
              />
            </div>
            <div className={styles.dropDown}>
              <Select
                value={selected?.label}
                onChange={(e) => {
                  return setSelected(e.value);
                }}
                options={tripType}
                defaultValue={{
                  value: "loading",
                  label: "Loading",
                }}
                styles={customStyles}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="custom-datatable mt-4">
        <DataTable
          title={null}
          columns={columns}
          data={tripData}
          progressPending={false}
          progressComponent={<Loading />}
          persistTableHead
          pagination={true}
          paginationServer
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={[10, 20, 30]}
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          customStyles={customStyles}
          className={""}
          highlightOnHover
          noDataComponent={<p className="pt-3 pb-2">Records not found</p>}
        />
      </div>
    </div>
  );
};

export default TripDashboard;
